import React, { useState } from 'react'
import { Input, Col, Row, Label } from 'reactstrap';
import Select from 'react-select';
import { Dialog } from 'primereact/dialog';
import './styleTotalOrder.css';



export const ModalTotalOrder = (props) => {

    const {

        // ? DIALOG
        toggleTotal,
        modalTotal,

        // ? CARD 1
        number_format,
        totalW,

        // ? CONFIGURATION DISCOUNT
        isAnyApplied,
        isCodeApplied,
        isPercentageApplied,
        percentage,
        isPreloadedApplied,
        id_preloaded_discount,

        // ? CONFIGURATION COMMON DISCOUNTS
        arrayCommonDiscounts,

        // ? CONFIGURATION PAY METHODS
        listPayMethods,
        validPorcentejeSpecial,
        handleDinamicInputWorkOrder,
        cedimi,
        isEditWorkOrder,
        listPayMethod,
        checkTypeClient,
        isPayForCompany,
        _adminFinance,
        AvailablePayMethodByCompany,
        validTotalCredit,
        _authorized_movement,
        handleUpdateMethod,
        handleCourtesy,
        listPayMethods_valid,
        showMessageW,
        handlePayBill,
        handleGiveChange,
        handleDeletePayMethod,
        validButton,
        handleAddPayMethodInputs,


        // ? INVOICE
        id_company,
        checkInvoice,
        handleInputChangeWorkOrder,
        requiere_invoice_patient_update,


        // ? TOTAL ORDERS
        showDiscountWarning,
        showDiscountWarningPay,
        listTest,
        loading,
        showButton,
        enableBtnSaveWorkOrder,
        saveUpdateWorkOrder,
        saveWorkOrder,
        modalPreviewUpdate,
        isPay,

        ListOptionsPaymentBy,
        OptionPaymentByCompany,
        OptionPaymentByPatient,
        PlaceHolderOption,
        handleChangeGeneratePay,

        toggleStudies,
        modalStudies,
        modalPayBills,
        ModalCourtesy,
        modalAutorization,

        insan,
        _branch_name,

        // ? LABCEN
        percentageDiscount,
        labcen,
        buap,
        sharp,
        hsjs,

        // ? COMPANY
        acceptCompany,
        setAcceptCompany,
        setFooterOpen,
        validate_update_payMethod,
        phersu,
        arcangeles








    } = props;

    var _Bonusses = false;
    var _Amount_Bonusses = 0;
    var _total_Bonusses = 0;

    const isZero = parseFloat(showMessageW.amount) === 0;





    return (

        <Dialog
            visible={modalTotal}
            onHide={toggleTotal}
            header={
                <div className="dialog-header-fix">

                    <div className="header-left-fix">


                        <span className="header-title-fix">
                            Cierre de venta
                        </span>
                    </div>

                    <div className="header-right-fix">

                        <div className="header-badge-fix">
                            <div
                                className="header-icon-fix"
                                onClick={() => {
                                    if (window.innerWidth > 768) {
                                        toggleStudies();
                                    }
                                }}
                            >
                                <i className="fa fa-flask"></i>
                            </div>

                            <i className="fa fa-vials"></i>
                            <span className="f-w-700 f-14 ">
                                {listTest.length} {listTest.length === 1 ? "Estudio" : "Estudios"}
                            </span>
                        </div>
                    </div>

                </div>
            }

            modal
            maskClassName="custom-total-mask"
            draggable={false}
            className={`custom-total-modal 
                     ${modalStudies ? "shift-left" : ""}
                        ${modalPayBills ? "shift-left" : ""}
                                `}

        >
            <Col sm="12" className="p-l-0 p-r-0">
                {
                    // * CONFIGURATION  TOTAL
                }
                <Col sm="12" className='p-l-0 p-r-0' >
                    <div className="total-card">

                        <div className="money-bg">
                            <span className="coin coin-sm"></span>
                            <span className="bill"></span>
                        </div>

                        <Row className="total-content">

                            <Col sm={checkTypeClient === 1 ? 6 : (id_company?.value && !isPayForCompany && isPay) ? 7 : 8} className='p-r-0' >
                                <div className="total-left">
                                    <div className="total-label">TOTAL NETO</div>
                                    <div className="total-amount">
                                        $ {number_format(_total_Bonusses ? _total_Bonusses : totalW, 2)}
                                    </div>
                                </div>
                            </Col>



                            <Col sm={checkTypeClient === 1 ? 6 : id_company?.value && !isPayForCompany && isPay ? 5 : 4} className='p-l-0' >
                                <div className={(validPorcentejeSpecial === buap || validPorcentejeSpecial === sharp || validPorcentejeSpecial === hsjs || validPorcentejeSpecial === labcen || validPorcentejeSpecial === arcangeles) ? "d-none" : ""} >

                                    {
                                        (checkTypeClient === 1 ||
                                            (id_company?.value &&
                                                !id_company?.require_invoice &&
                                                id_company?.available_invoice_patient &&
                                                requiere_invoice_patient_update)) && (

                                            <div className={`invoice-card-v2 inside ${checkInvoice ? "active" : ""}`}>
                                                <span className="coin c1"></span>
                                                <span className="coin c2"></span>
                                                <span className="coin c3"></span>


                                                <div className="invoice-left-v2">
                                                    <div className="invoice-icon-v2">
                                                        <i className="fa fa-file-text-o"></i>
                                                    </div>

                                                    <div>
                                                        <div className="invoice-title-v2">¿Requiere factura?</div>
                                                    </div>
                                                </div>

                                                <Label className="switch-v2">
                                                    <Input
                                                        type="checkbox"
                                                        name="checkInvoice"
                                                        onChange={(e) => handleInputChangeWorkOrder(e)}
                                                        checked={checkInvoice}
                                                    />
                                                    <span className="slider-v2"></span>
                                                </Label>

                                            </div>
                                        )
                                    }
                                </div>

                                {id_company?.value && (
                                    <div className="footer-chip success">
                                        <i className="fa fa-credit-card"></i>
                                        <span>
                                            Pago:  {
                                                id_company?.value && isPayForCompany && <b className=''>La empresa</b>
                                            }
                                            {
                                                id_company?.value && !isPayForCompany && !isPay && <b className=''>El paciente</b>
                                            }
                                            {
                                                id_company?.value && !isPayForCompany && isPay && <b className=''>Ambas partes</b>
                                            }
                                        </span>
                                    </div>
                                )}
                                {
                                    (id_company?.payment_by_company && id_company?.payment_by_patient) && <div className='pt-2' >
                                        <Select
                                            classNamePrefix='select'
                                            name="payment_by"
                                            options={ListOptionsPaymentBy}
                                            value={isPayForCompany ? OptionPaymentByCompany : OptionPaymentByPatient}
                                            onChange={(e) => handleChangeGeneratePay(e)}
                                            placeholder={PlaceHolderOption}
                                            isSearchable={false}
                                            styles={{
                                                control: (base, state) => ({
                                                    ...base,
                                                    minHeight: "28px",
                                                    height: "28px",
                                                    borderRadius: "8px",
                                                    background: "rgba(255,255,255,0.08)", // 🔥 glass oscuro
                                                    border: state.isFocused
                                                        ? "1px solid #f97316"
                                                        : "1px solid rgba(255,255,255,0.15)",
                                                    boxShadow: "none",
                                                    fontSize: "11px",
                                                    backdropFilter: "blur(6px)",
                                                    cursor: "pointer",
                                                    "&:hover": {
                                                        border: "1px solid #f97316"
                                                    }
                                                }),

                                                valueContainer: (base) => ({
                                                    ...base,
                                                    padding: "0 8px",
                                                }),

                                                indicatorsContainer: (base) => ({
                                                    ...base,
                                                    height: "28px",
                                                }),

                                                dropdownIndicator: (base, state) => ({
                                                    ...base,
                                                    padding: "0 6px",
                                                    color: state.isFocused ? "#f97316" : "#363636",
                                                }),

                                                indicatorSeparator: () => ({
                                                    display: "none"
                                                }),

                                                singleValue: (base) => ({
                                                    ...base,
                                                    color: "#fff",
                                                    fontWeight: 500
                                                }),

                                                placeholder: (base) => ({
                                                    ...base,
                                                    color: "rgba(255,255,255,0.6)"
                                                }),

                                                menu: (base) => ({
                                                    ...base,
                                                    borderRadius: "10px",
                                                    overflow: "hidden",
                                                    fontSize: "12px",
                                                    background: "#1e293b",
                                                }),

                                                option: (base, state) => ({
                                                    ...base,
                                                    fontSize: "12px",
                                                    backgroundColor: state.isSelected
                                                        ? "#f97316"
                                                        : state.isFocused
                                                            ? "rgba(249,115,22,0.15)"
                                                            : "#1e293b",
                                                    color: state.isSelected ? "#fff" : "#e2e8f0",
                                                    cursor: "pointer"
                                                })
                                            }}
                                        />
                                    </div>
                                }
                            </Col>

                        </Row>
                    </div>
                </Col>
                {
                    // * CONFIGUTAION PAYMETS COMPANY

                }
                {

                    arrayCommonDiscounts.length > 0 && !isEditWorkOrder && <div className={checkTypeClient === 1 ? "section pt-4" : "d-none"}>
                        <label className="section-titleo">
                            <i className="fa fa-percent"></i> Campaña
                        </label>
                        <div className="discount-dropdown">


                            <div className="dropdown-warning">
                                <i className="fa fa-exclamation-circle"></i>

                                <span>
                                    {
                                        arrayCommonDiscounts.length > 0 &&
                                        arrayCommonDiscounts.map((_common, index) => (
                                            <div className="common-discount-info">
                                                <span className="title">{_common.name}</span>

                                            </div>
                                        ))
                                    }
                                </span>
                            </div>

                        </div>
                    </div>



                }
                {
                    // * CONFIGURATION DISCOUNT LABCEN
                }
                {
                    percentageDiscount !== 0 && validPorcentejeSpecial === labcen && <div className={checkTypeClient === 1 ? "section pt-4" : "d-none"}>
                        <label className="section-titleo">
                            <i className="fa fa-percent"></i> DESCUENTO
                        </label>
                        <div className="discount-dropdown">


                            <div className="dropdown-warning">
                                <i className="fa fa-exclamation-circle"></i>

                                <span>
                                    {`Descuento del ${percentageDiscount}% aplicado`}

                                </span>
                            </div>

                        </div>
                    </div>


                }
                {
                    // * CONFIGURATION DISCOUNTS
                }
                {
                    isAnyApplied && <div className={checkTypeClient === 1 ? "section pt-4" : "d-none"}>
                        <label className="section-titleo">
                            <i className="fa fa-percent"></i> DESCUENTO
                        </label>
                        <div className="discount-dropdown">

                            {isAnyApplied && (
                                <div className="dropdown-warning">
                                    <i className="fa fa-exclamation-circle"></i>

                                    <span>
                                        {isCodeApplied && "Código promocional aplicado"}
                                        {isPercentageApplied && `Descuento del ${percentage}% aplicado`}
                                        {isPreloadedApplied && (
                                            <>
                                                {id_preloaded_discount?.label} ({id_preloaded_discount?.valuePercentage}%)
                                                {" - Previa autorización del Director Comercial"}
                                            </>
                                        )}
                                    </span>
                                </div>
                            )}
                        </div>
                    </div>
                }
                {
                    // * CONFIGURATION PAY METHODS
                }

                <Col sm="12  " className='p-l-0 p-r-0 pt-3' >
                    <label className="section-title">
                        <i className="pi pi-wallet"></i> Detalles del pago
                        {
                            (!validTotalCredit && validButton) &&
                            <div className="pay-header-actions">
                                <button
                                    type='button'
                                    className='btn-add-pay'
                                    onClick={handleAddPayMethodInputs}
                                >
                                    <i className='fa fa-plus'></i> Método de pago
                                </button>
                            </div>
                        }
                    </label>

                    <div className="pay-container pt-2">
                        {
                            listPayMethods.map((_paymethod, keyPayment) => {

                                // ! BONUSES CEDIMI
                                _Bonusses = (_paymethod.id_pay_method === "31" || _paymethod.id_pay_method === 31) && validPorcentejeSpecial === cedimi ? true : false;

                                if (_Bonusses) {
                                    _Amount_Bonusses = _paymethod.amount;
                                    _total_Bonusses = (totalW - _paymethod.amount);
                                }

                                return (
                                    <div key={`method-${keyPayment}`} className={`pay-card ${_paymethod.deleted ? 'd-none' : ''}`}>

                                        {
                                            // *METHOD
                                        }
                                        <div className="pay-field pay-field-method">
                                            <label>Método</label>
                                            <Input
                                                type="select"
                                                required
                                                className={_Bonusses ? 'pay-select Bonusses' : 'pay-select'}
                                                value={_paymethod.id_pay_method}
                                                data-id={keyPayment}
                                                onChange={(e) => handleDinamicInputWorkOrder(e, "id_pay_method", "listPayMethods")}
                                                disabled={
                                                    validTotalCredit
                                                        ? true
                                                        : (_paymethod.id_work_order_pay !== undefined && _paymethod.id_work_order_pay !== null)
                                                            ? true
                                                            : (totalW >= 0 ? false : true)
                                                }
                                            >
                                                <option value={0}>
                                                    {isEditWorkOrder && _Bonusses ? "Bonificación" : "Selecciona una opción"}
                                                </option>

                                                {
                                                    listPayMethod.map(_pMethod => {

                                                        if (validPorcentejeSpecial === cedimi && _pMethod?.id_pay_method === 31) {
                                                            if (checkTypeClient === 3 || isEditWorkOrder) return null;
                                                        }

                                                        if (checkTypeClient === 3 && isPayForCompany) {
                                                            if (_pMethod.name === AvailablePayMethodByCompany) {
                                                                return (
                                                                    <option key={_pMethod.id_pay_method} value={_pMethod.id_pay_method}>
                                                                        {_pMethod.abbreviation} - {_pMethod.name}
                                                                    </option>
                                                                )
                                                            }
                                                        }
                                                        else if (_pMethod.abbreviation !== "CONV") {

                                                            if (_adminFinance === "True") {
                                                                return (
                                                                    <option key={_pMethod.id_pay_method} value={_pMethod.id_pay_method}>
                                                                        {_pMethod.abbreviation} - {_pMethod.name}
                                                                    </option>
                                                                )
                                                            }
                                                            else if (_pMethod.visibility_particular === true) {
                                                                return (
                                                                    <option key={_pMethod.id_pay_method} value={_pMethod.id_pay_method}>
                                                                        {_pMethod.abbreviation} - {_pMethod.name}
                                                                    </option>
                                                                )
                                                            }
                                                        }

                                                        return null;
                                                    })
                                                }

                                            </Input>
                                        </div>

                                        {
                                            // * AMOUNT 
                                        }

                                        <div className="pay-field pay-field-amount">
                                            <label>Monto</label>
                                            <Input
                                                type="number"
                                                name="amount"
                                                data-id={keyPayment}
                                                value={_paymethod.amount}
                                                placeholder="$ 0.0"
                                                step="any"
                                                className={_Bonusses ? 'pay-input Bonusses' : 'pay-input'}
                                                onChange={(e) => handleGiveChange(e, "amount", "listPayMethods")}
                                                disabled={
                                                    validTotalCredit
                                                        ? true
                                                        : (_paymethod.id_work_order_pay !== undefined && _paymethod.id_work_order_pay !== null)
                                                            ? true
                                                            : (totalW >= 0 ? false : true)
                                                }
                                            />
                                        </div>

                                        {
                                            // * ACTIONS
                                        }

                                        <div className={`pay-actions ${validTotalCredit ? "d-none" : "pt-4"}`}>
                                            {
                                                (_paymethod.fully_paid !== undefined && !_paymethod.fully_paid) ?
                                                    <button
                                                        type='button'
                                                        className='btn-pay-action success'
                                                        title='Liquidar saldo'
                                                        onClick={() => handlePayBill(_paymethod.id_work_order_pay, _paymethod.amount)}
                                                    >
                                                        <i className="fa fa-money txt-success f-22"></i>
                                                    </button>
                                                    :
                                                    <button
                                                        type='button'
                                                        className='btn-pay-action danger'
                                                        onClick={() => handleDeletePayMethod(keyPayment)}
                                                        disabled={(_paymethod.id_work_order_pay !== undefined && _paymethod.id_work_order_pay !== null) ? true : (totalW > 0 ? false : true)}
                                                    >
                                                        <i className='icofont icofont-ui-delete txt-danger f-22'></i>
                                                    </button>
                                            }
                                            {
                                                (_authorized_movement === "True" && _paymethod.fully_paid && isEditWorkOrder) &&
                                                <div
                                                    className={
                                                        (validPorcentejeSpecial === insan || validPorcentejeSpecial === phersu)
                                                            ? (validate_update_payMethod === true || _authorized_movement === "True")
                                                                ? ""
                                                                : "d-none"
                                                            : ""
                                                    }
                                                >
                                                    <button
                                                        className="btn-pay-action"
                                                        onClick={handleUpdateMethod}
                                                        title="Modificar forma de pago"
                                                    >
                                                        <i className="icofont icofont-coins txt-secondary f-22"></i>
                                                    </button>
                                                </div>
                                            }

                                            {
                                                validPorcentejeSpecial === insan &&
                                                (_paymethod.id_pay_method !== 29 && _adminFinance === "True" && isEditWorkOrder) &&
                                                <button
                                                    className="btn-pay-action warning"
                                                    onClick={handleCourtesy}
                                                    title='Activar membresia'
                                                >
                                                    <i className="fa fa-user txt-danger f-22"></i>
                                                </button>
                                            }

                                        </div>

                                    </div>
                                )
                            })
                        }
                        {!validTotalCredit && (
                            <div className={modalPayBills ? "d-none" : "pay-total-wrapper"} >

                                {(() => {
                                    const isCambio = showMessageW.labelMoney === "Cambio";
                                    const amount = Number(showMessageW.amount);
                                    const isZeroAmount = amount === 0;

                                    let className = "pay-status show";
                                    let icon = "fa-dollar";
                                    let label = "";
                                    let value = "";

                                    if (isCambio) {
                                        if (isZeroAmount) {
                                            className += " pay-green";
                                            icon = "fa-check-circle";
                                            label = "Cambio";
                                            value = "$0.00";
                                        } else {
                                            className += " pay-blue";
                                            icon = "fa-exchange";
                                            label = "Cambio";
                                            value = `$ ${number_format(amount, 2)}`;
                                        }
                                    } else {
                                        if (isZero) {
                                            className += " pay-green";
                                            icon = "fa-check-circle";
                                            label = "Cambio";
                                            value = "$0.00";
                                        } else {
                                            className += " pay-orange ";
                                            icon = "fa-dollar";
                                            label = showMessageW.labelMoney;
                                            value = `$ ${number_format(amount, 2)}`;
                                        }
                                    }

                                    return (
                                        <div className={className}>
                                            <i className={`fa ${icon}`}></i>

                                            <div className="pay-text">
                                                <span className="pay-label">{label}:</span>
                                                <span className="pay-value">{value}</span>
                                            </div>
                                        </div>
                                    );
                                })()}

                            </div>
                        )}

                        <Col sm="12" className='p-l-0 p-r-0 pt-2' >
                            {
                                validPorcentejeSpecial === insan && (
                                    <div className="alert-ribbon-branch">
                                        <i className="fa fa-map-marker"></i>
                                        <span>Sucursal: {_branch_name}</span>
                                    </div>
                                )
                            }
                        </Col>

                        {
                            // ? CONFIGURATION COMPANY  
                        }
                        {
                            id_company?.value && (
                                <Col sm="12" className={isEditWorkOrder ? "d-none" : 'pl-0 pr-0'}   >
                                    <div className="confirm-company-box">

                                        <div className="confirm-text">
                                            ¿Continuara realizando más ingresos de esta empresa?
                                        </div>


                                        <div className="company-check">
                                            <label className="company-check-switch">
                                                <input
                                                    type="checkbox"
                                                    checked={acceptCompany}
                                                    onChange={(e) => setAcceptCompany(e.target.checked)}
                                                />
                                                <span className="company-check-slider"></span>
                                            </label>

                                            <span className={acceptCompany ? "labelActiveCompany" : "company-check-label"} >

                                                Sí, deseo continuar
                                            </span>
                                        </div>

                                    </div>
                                </Col>
                            )
                        }



                        <Row className='m-t-15'>
                            <Col sm="12">
                                {showDiscountWarning && (
                                    <h7 style={{ color: 'red' }}>¡El porcentaje de descuento debe estar entre 0 y 100!</h7>
                                )}
                                {showDiscountWarningPay && (
                                    <h7 style={{ color: 'red' }}>¡Excediste el crédito!</h7>
                                )}
                                {
                                    listTest.length > 0 &&
                                    <>
                                        {
                                            listTest.length > 0 &&
                                            <>
                                                {
                                                    isEditWorkOrder ? (
                                                        <button
                                                            className={`btn-main-action ${loading ? "loading" : ""}`}
                                                            disabled={
                                                                validTotalCredit ? false :
                                                                    showButton === false
                                                                        ? enableBtnSaveWorkOrder
                                                                        : (showDiscountWarning || showDiscountWarningPay)
                                                                            ? true
                                                                            : false
                                                            }
                                                            onClick={() => {
                                                                saveUpdateWorkOrder();
                                                                setFooterOpen(false);
                                                            }}
                                                        >
                                                            <span>{loading ? "Actualizando venta" : "Actualizar Venta"}</span>
                                                        </button>
                                                    ) : (
                                                        <button
                                                            className={`btn-main-action ${loading ? "loading" : ""}`}
                                                            disabled={validTotalCredit ? false : enableBtnSaveWorkOrder}
                                                            onClick={() => {
                                                                saveWorkOrder(undefined, acceptCompany);
                                                                setFooterOpen(false);
                                                            }}
                                                        >
                                                            <span>{"Finalizar Venta"}</span>
                                                        </button>
                                                    )
                                                }
                                            </>
                                        }

                                    </>
                                }
                            </Col>
                        </Row>


                    </div>
                </Col>
            </Col>
        </Dialog >

    )
}

